import styled from 'styled-components';

export const ClassFilterTitle = styled.h6`
  color: ${({ theme }) => theme.palette.grey1100};
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  margin-bottom: 0px;
`;

export const ClassChipList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
`;

export const ClassChip = styled.button<{ $selected: boolean }>`
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 64px;
  height: 36px;
  padding: 0 14px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  color: ${({ theme }) => theme.palette.grey1100} !important;
  background-color: ${({ theme }) =>
    theme.palette.inputBackgroundColor} !important;
  border: solid 1px
    ${({ $selected, theme }) =>
      $selected ? theme.palette.grey1100 : theme.palette.grey300} !important;
  transition: border-color 0.15s ease;

  img {
    display: block;
    flex-shrink: 0;
  }

  &:hover {
    border-color: ${({ theme }) => theme.palette.grey1100};
  }
`;
